import { useContext } from 'react'
import { useIntl } from 'react-intl'

import Modal from 'LuxKit/Modal/Modal'

import GeoContext from 'contexts/geoContext'
import { depositAmountStringBuilder } from 'lib/tours/tourUtils'
import type { Props as DepositInfoModalContentProps } from './DepositInfoModalContent'
import DepositInfoModalContent from './DepositInfoModalContent'

import { getDefaultDepositAmountPercentage } from 'checkout/selectors/featureConfig/deposit'
import { isOfferDefaultDepositAmountPercentage } from 'lib/payment/depositsUtils'
import { useAppSelector } from 'hooks/reduxHooks'

interface Props extends DepositInfoModalContentProps {
  isModalOpen?: boolean
  onCloseModal?: () => void
}

export function DepositInfoModal({ isModalOpen, onCloseModal, ...rest }: Props) {
  const intl = useIntl()
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)
  const defaultDepositAmountPercentage = useAppSelector(getDefaultDepositAmountPercentage)

  const isOfferUsingDefaultDepositPercentage = isOfferDefaultDepositAmountPercentage(rest.depositThresholds, rest.depositAmount)

  const payADepositHeading = intl.formatMessage({
    id: '8yZ3J-yXeh0ewGq3MO84',
    defaultMessage: 'Pay a deposit',
    description: 'Modal heading for the deposit payment information in a modal dialog',
  })

  const standardModalHeading = isOfferUsingDefaultDepositPercentage ? payADepositHeading : rest.depositType ?
      intl.formatMessage(
        {
          id: 'FkKgPGSGhK997Z4N0h7F',
          defaultMessage: 'Pay {depositAmount} deposit',
          description: 'Modal heading showing deposit amount to pay for a tour or hotel booking',
        },
        { depositAmount: depositAmountStringBuilder(defaultDepositAmountPercentage, rest.depositType, rest.depositAmountPercentage, intl, currentCurrency, currentRegionCode).short },
      ) :
      intl.formatMessage(
        {
          id: 'gpNyPNglcut6xMtIj1Q-',
          defaultMessage: 'Pay {percentage}% deposit',
          description: 'Modal heading showing deposit percentage to pay for a tour or hotel booking',
        },
        { percentage: rest.depositAmountPercentage },
      )

  return (
    <Modal
      title={standardModalHeading}
      isOpen={isModalOpen}
      onClose={onCloseModal}
    >
      <DepositInfoModalContent {...rest} />
    </Modal>
  )
}
